import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const NAMES = ['Sofía', 'María', 'Valentina', 'Camila', 'Isabella', 'Daniela', 'Fernanda', 'Lucía', 'Ana', 'Gabriela', 'Paola', 'Andrea'];
const COUNTRIES = ['México', 'Colombia', 'Argentina', 'Chile', 'Perú', 'Venezuela', 'Ecuador', 'Uruguay', 'Bolivia', 'Paraguay'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    country: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      setData({
        name: randomName,
        country: randomCountry
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Loop
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, 15000 + Math.random() * 5000); // Random interval between 15-20s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-135">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -50
    }} className="fixed bottom-4 left-4 z-50 bg-white shadow-xl rounded-xl p-3 flex items-center gap-3 border border-gray-100 max-w-[300px]" data-id="element-136">
          <div className="bg-coral-100 p-2 rounded-lg text-coral-600" data-id="element-137">
            <ShoppingBag size={20} data-id="element-138" />
          </div>
          <div data-id="element-139">
            <p className="text-sm text-gray-800" data-id="element-140">
              <span className="font-bold" data-id="element-141">{data.name}</span> de {data.country}
            </p>
            <p className="text-xs text-gray-500" data-id="element-142">
              acaba de comprar el protocolo
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}